import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestPostsBulkMovePut = {
    path: "/posts/bulk/move",
    method: RouteHttpVerb.PUT
};
export { locationRestPostsBulkMovePut };
